import { Form, Modal, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { closeModal } from "store/slices/modalsSlice";
import { deletePromotionById } from "store/slices/promotionsSlice";

const DeletePromotionModal = () => {
  const dispatch = useDispatch();

  const {
    isModalOpen,
    modalType,
    modalProps: { id },
  } = useSelector((state) => state?.modals);

  const { loading } = useSelector((state) => state?.promotions);

  const open = isModalOpen && modalType === "delete_promotion";

  /* -------------------- SUBMIT -------------------- */
  const onSubmit = async () => {
    try {
      await dispatch(deletePromotionById(id)).unwrap();

      notification.success({
        message: "Promotion deleted",
        description: "The promotion has been deleted successfully",
      });

      dispatch(closeModal());
    } catch (error) {
      notification.error({
        message: "Delete failed",
        description: error?.message || "Something went wrong",
      });
    }
  };

  return (
    <Modal
      title="Delete Promotion"
      open={open}
      onOk={onSubmit}
      confirmLoading={loading}
      onCancel={() => dispatch(closeModal())}
      okText="Delete"
      okType="danger"
      cancelText="Cancel"
      centered
    >
      <Form>
        Are you sure you want to delete this promotion?
      </Form>
    </Modal>
  );
};

export default DeletePromotionModal;
